import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'
import BaixarDocumentoAnuenciaInput from '@/core/apiclient/anuencia/documento/models/BaixarDocumentoAnuenciaInput'

const URL_PATH = '/ata-registro-preco/api/public/adesao'

class DocumentosAnuenciaApiClient {
	async baixar(documento) {
		const { idDocumento, tipoRegistroDocumento, situacaoDocumento } = documento
		const input = new BaixarDocumentoAnuenciaInput(idDocumento, tipoRegistroDocumento, situacaoDocumento)

		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/documentos/${input.idDocumento}/baixar`,
			filters: {
				tipoRegistroDocumento: input.tipoRegistroDocumento,
				situacaoDocumento: input.situacaoDocumento,
			},
		}).build()

		return await axios.get(url, {
			responseType: 'arraybuffer',
		})
	}
}

export default new DocumentosAnuenciaApiClient()
